import type React from 'react';

export interface MyProfileIconProps {
	width?: string | number;
	height?: string | number;
	color?: string;
	'aria-label'?: string;
}

const WarningIcon: React.FC<MyProfileIconProps> = ({
	width = 24,
	height = 24,
	color = 'currentColor',
	'aria-label': ariaLabel = 'Warning Icon',
}) => (
	<svg
		width={width}
		height={height}
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		stroke="currentColor"
		stroke-width="2"
		stroke-linecap="round"
		stroke-linejoin="round"
		aria-label={ariaLabel}
		style={{ color }}
	>
		<path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
		<line x1="12" y1="9" x2="12" y2="13" />
		<line x1="12" y1="17" x2="12" y2="17" />
	</svg>
);

export default WarningIcon;